import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { MessageSquare } from "lucide-react";
import NotesSection from "./notes-section";

interface NotesDialogProps {
  entityType: string;
  entityId: string;
  entityName: string;
  trigger?: React.ReactNode;
}

export default function NotesDialog({ entityType, entityId, entityName, trigger }: NotesDialogProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        {trigger || (
          <Button variant="ghost" size="sm">
            <MessageSquare className="w-4 h-4 mr-2" />
            Notes
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Notes for {entityName}</DialogTitle>
          <DialogDescription>
            Add, edit, or view notes for this item. Notes can be marked as internal or external.
          </DialogDescription>
        </DialogHeader>
        <NotesSection entityType={entityType} entityId={entityId} title="" />
      </DialogContent>
    </Dialog>
  );
}